"use strict";

/* eslint-disable no-undef */
// @ts-expect-error This is replaced at build time by Webpack Define Plugin.
// The value is read from `redwood.toml`
window.__REDWOOD__API_PROXY_PATH = __REDWOOD__API_PROXY_PATH;